import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import BookshareReader from "./BookshareReader";
import { AnnotationsProvider } from "./contexts/AnnotationsContext";
import reportWebVitals from "./reportWebVitals";

const bookshareId = new URL(window.location).searchParams.get("bookshareId");
const isRnib = window.location.hostname.endsWith(".rnibbookshare.org");

ReactDOM.render(
  <React.StrictMode>
    <AnnotationsProvider bookshareId={bookshareId} isRnib={isRnib}>
      <BookshareReader bookshareId={bookshareId} isRnib={isRnib} />
    </AnnotationsProvider>
  </React.StrictMode>,
  document.getElementById("root"),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
